import { useNavigate } from "react-router-dom";
import Button from "./Button";

export default function BackButton({ text, onClick }) {
    const navigate = useNavigate();

    const handleOnClick = () => {
        if (onClick) {
            onClick();
        } else {
            navigate(-1)
        }
    };

    return (
        <Button className="btn-sm btn-secondary"
            onClick={handleOnClick}
            id="back-button"
            icon={<i className="bi bi-chevron-left me-1"></i>}
            text={text || 'Back'}
            iconLocation="start"
        />
    )
}